import * as yup from 'yup';

import {
  EquipmentCountRow,
  equipmentCountSchema,
} from 'components/modules/EquipmentCountSection';

export const initialValues = (
  packageSkus: {
    name: string;
    totalQuantity: number;
    _id: string;
    items: any;
  }[],
  itemsPerPackage: any,
  washHub: string,
  equipment: EquipmentCountRow[] = [],
) => ({
  washHub: washHub,
  date: '',
  fullPackages: packageSkus
    .map((sku) => ({
      sku: sku._id,
      skuName: sku.name,
      caseCount: 0,
      totalItems: 0,
      totalQuantity: sku.totalQuantity,
      items: sku.items,
    }))
    .sort((a: any, b: any) => {
      return a.skuName.localeCompare(b.skuName);
    }),

  inBoxes: itemsPerPackage
    // .flat() // Flatten the nested array
    .map((item: any) => ({
      sku: item.sku,
      skuName: item.skuName,
      boxCount: 0,
      itemsPerBox: 0,
      totalItems: 0,
    }))
    .sort((a: any, b: any) => {
      return a.skuName.localeCompare(b.skuName);
    }),
  inProcess: itemsPerPackage
    //.flat()
    .map((item: any) => ({
      sku: item.sku,
      skuName: item.skuName,
      itemCount: 0,
    }))
    .sort((a: any, b: any) => {
      return a.skuName.localeCompare(b.skuName);
    }),
  equipment,
  notes: '',
});

export const validationSchema = yup.object().shape({
  notes: yup.string().required('Notes is required'),
  date: yup.string().required('Count Date is required'),
  washHub: yup.string().required('Wash Hub is required'),
  fullPackages: yup.array().of(
    yup.object().shape({
      caseCount: yup.number().required('Case Count is required'),
    }),
  ),
  inBoxes: yup.array().of(
    yup.object().shape({
      boxCount: yup.number().required('Box Count is required'),
      itemsPerBox: yup.number().required('Items Per Box is required'),
    }),
  ),
  inProcess: yup.array().of(
    yup.object().shape({
      itemCount: yup.number().required('Item Count is required'),
    }),
  ),
  equipment: equipmentCountSchema,
});
